import script from "./ConfermaOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfermaOrdine.vue?vue&type=script&setup=true&lang=js"

import "./ConfermaOrdine.vue?vue&type=style&index=0&id=a91b3b3e&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a91b3b3e"]])

export default __exports__